import { Injectable } from '@angular/core';
import { AppHttpClient } from '../api.interceptor';
import { environment } from '@env/environment';

@Injectable()
export class AuthRequests {
  private config = environment;

  constructor(
    private http: AppHttpClient
  ) {
  }

  /**
   * Login in the application with given credentials
   * @param payload: Object<any>
   */
  login(payload) {
    // const url = `${this.config.baseUrl}/${this.config.services.auth}/token`;
    const url = `${this.config.baseUrl}/v2/${this.config.services.users}/login`;
    return this.http.post(url, payload);
  }

  /**
   * Sign up in the application with given credentials
   * @param payload: Object<any>
   */
  signup(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.accounts}`;
    return this.http.post(url, payload);
  }

  /**
   * Invite team mates to a company
   * @param accountId companyId
   * @param payload array of teammates
   */
  inviteTeammates(accountId, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.accounts}/${accountId}/users`;
    return this.http.post(url, payload);
  }

  /**
 * Invite team mates to a contract
 * @param contractId contract id
 * @param payload array of teammates
 */
  inviteToContract(contractId, payload, type) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/users/${type}`;
    return this.http.post(url, payload);
  }
  /**
   * Recover password endpoint
   * @param payload Object<any>
   */
  forgotPassword(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.users}/forgot-password`;
    return this.http.post(url, payload);
  }

  /**
   * Get configuration keys
   */
  getConfigurationKeys() {
    const url = `${this.config.baseUrl}/v2/configuration/keys`;
    return this.http.get(url);
  }

  /**
   * Refresh app tolem
   * @param token refresh token
   */
  refreshToken(token) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.users}/refresh_token`;
    const payload = {
      refreshToken: token
    };
    return this.http.post(url, payload);
  }
}
